goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_clockwise_2_svg");
goog.provide("module$shadow_js_shim_module$src$svg$arrows$arrow_clockwise_2_svg");
shadow.js.shim.module$src$svg$arrows$arrow_clockwise_2_svg = shadow.js.nativeProvides["src/svg/arrows/arrow-clockwise-2.svg"] = shadow$bridge("src/svg/arrows/arrow-clockwise-2.svg");
module$shadow_js_shim_module$src$svg$arrows$arrow_clockwise_2_svg.default = shadow.js.shim.module$src$svg$arrows$arrow_clockwise_2_svg;
